// WeCom Management —— English i18n
// Namespace: app.wecom.*

export const enGB_wecom = {
	// Page titles
	'app.wecom.activeCode.title': 'Live Codes',
	'app.wecom.colleague.title': 'Colleagues',
	'app.wecom.group.title': 'Group Chats',
	'app.wecom.customer.title': 'Customers',

	// Common placeholder (used by colleague/group/customer pages)
	'app.wecom.placeholder': 'This page is coming soon.',

	// ===== Active Code Page =====

	// Search area
	'app.wecom.activeCode.search.name': 'Code Name',
	'app.wecom.activeCode.search.name.placeholder': 'Please enter',
	'app.wecom.activeCode.search.scope': 'Scope',
	'app.wecom.activeCode.search.scope.placeholder': 'Please select',
	'app.wecom.activeCode.search.creator': 'Creator',
	'app.wecom.activeCode.search.creator.placeholder': 'Please select',
	'app.wecom.activeCode.search.status': 'Status',
	'app.wecom.activeCode.search.status.placeholder': 'Please select',
	'app.wecom.activeCode.search.createTime': 'Created',
	'app.wecom.activeCode.search.createTime.range': 'Select date range',

	// Status enum
	'app.wecom.activeCode.status.active': 'Active',
	'app.wecom.activeCode.status.disabled': 'Disabled',

	// Table columns
	'app.wecom.activeCode.table.name': 'Code Name',
	'app.wecom.activeCode.table.scope': 'Scope',
	'app.wecom.activeCode.table.owner': 'Owner',
	'app.wecom.activeCode.table.customerCount': 'Customers',
	'app.wecom.activeCode.table.tags': 'Tags',
	'app.wecom.activeCode.table.creator': 'Creator',
	'app.wecom.activeCode.table.createTime': 'Created',

	// Action buttons
	'app.wecom.activeCode.button.create': 'New Code',
	'app.wecom.activeCode.button.export': 'Export',
	'app.wecom.activeCode.button.download': 'Download',
	'app.wecom.activeCode.button.addRecord': 'Add History',

	// Detail Modal
	'app.wecom.activeCode.detail.title': 'Code Details',
	'app.wecom.activeCode.detail.name': 'Code Name',
	'app.wecom.activeCode.detail.url': 'QR Code URL',
	'app.wecom.activeCode.detail.scope': 'Scope',
	'app.wecom.activeCode.detail.owner': 'Owner',
	'app.wecom.activeCode.detail.customerCount': 'Customers',
	'app.wecom.activeCode.detail.tags': 'Tags',
	'app.wecom.activeCode.detail.creator': 'Creator',
	'app.wecom.activeCode.detail.createTime': 'Created',
	'app.wecom.activeCode.detail.status': 'Status',

	// Add History Drawer
	'app.wecom.activeCode.addRecord.title': 'Add History',
	'app.wecom.activeCode.addRecord.target': 'Code',
	'app.wecom.activeCode.addRecord.column.customer': 'Customer',
	'app.wecom.activeCode.addRecord.column.addTime': 'Added At',
	'app.wecom.activeCode.addRecord.column.tags': 'Tags',
	'app.wecom.activeCode.addRecord.empty': 'No add history',

	// Empty state
	'app.wecom.activeCode.empty': 'No codes yet. Click "New Code" to create one.',

	// ===== Colleague Page =====
	'app.wecom.colleague.search.placeholder': 'Search by group, name, or phone',
	'app.wecom.colleague.title.suffix': '({count})',
	'app.wecom.colleague.table.name': 'Name',
	'app.wecom.colleague.table.department': 'Department',
	'app.wecom.colleague.table.phone': 'Phone',
	'app.wecom.colleague.table.email': 'Email',
	'app.wecom.colleague.empty': 'No colleagues in this department',

	// ===== Group Chat Page =====

	// Search area
	'app.wecom.group.search.name': 'Group Name',
	'app.wecom.group.search.name.placeholder': 'Please enter',
	'app.wecom.group.search.owner': 'Owner',
	'app.wecom.group.search.owner.placeholder': 'Please select',
	'app.wecom.group.search.member': 'Member',
	'app.wecom.group.search.member.placeholder': 'Please select',
	'app.wecom.group.search.createTime': 'Created',
	'app.wecom.group.search.createTime.range': 'Select date range',
	'app.wecom.group.search.status': 'Status',
	'app.wecom.group.search.status.placeholder': 'Please select',

	// Status enum
	'app.wecom.group.status.active': 'Active',
	'app.wecom.group.status.archived': 'Archived',
	'app.wecom.group.status.dissolved': 'Dissolved',

	// Table columns
	'app.wecom.group.table.name': 'Customer Group',
	'app.wecom.group.table.tags': 'Tags',
	'app.wecom.group.table.owner': 'Owner',
	'app.wecom.group.table.memberCount': 'Members',
	'app.wecom.group.table.createTime': 'Created',

	// Action buttons(群聊无需操作列 —— 直接点群名进详情)
	// 'app.wecom.group.button.detail': 'Details',
	// 'app.wecom.group.button.sync': 'Sync',

	// Detail Modal (header + info rows + announcement + Tabs)
	'app.wecom.group.detail.title': 'Customer Group Details',
	'app.wecom.group.detail.owner': 'Owner',
	'app.wecom.group.detail.createTime': 'Created',
	'app.wecom.group.detail.tags': 'Tags',
	'app.wecom.group.detail.description': 'Description',
	'app.wecom.group.detail.announcement': 'Group Announcement',
	'app.wecom.group.detail.announcement.empty': 'No group announcement',

	// Detail Tabs
	'app.wecom.group.detail.tab.activity': 'Activity',
	'app.wecom.group.detail.tab.members': 'Members',
	'app.wecom.group.detail.tab.archive': 'Session Archive',

	// Detail Tab — Members
	'app.wecom.group.detail.member.name': 'Member',
	'app.wecom.group.detail.member.remark': 'Remark',
	'app.wecom.group.detail.member.joinTime': 'Joined At',
	'app.wecom.group.detail.member.joinWay': 'Way',
	'app.wecom.group.detail.member.joinWay.invite': 'Invited by a member',
	'app.wecom.group.detail.member.joinWay.scan': 'Scan to join',
	'app.wecom.group.detail.member.joinWay.direct': 'Direct invite',
	'app.wecom.group.detail.member.internalTag': 'Internal',
	'app.wecom.group.detail.member.batchRemark': 'Batch Remark',
	'app.wecom.group.detail.member.empty': 'No group members',

	// Detail Tab — Archive
	'app.wecom.group.detail.archive.empty': 'No more data',

	// Empty state
	'app.wecom.group.empty': 'No customer groups. Try adjusting filters or sync WeCom.',

	// ===== Customer Page =====

	// Search area (4 per row, 7 fields)
	'app.wecom.customer.search.name': 'Customer Name',
	'app.wecom.customer.search.name.placeholder': 'Search by nickname or remark',
	'app.wecom.customer.search.source': 'Source',
	'app.wecom.customer.search.source.placeholder': 'Please select',
	'app.wecom.customer.search.linkedCrm': 'Linked to CRM',
	'app.wecom.customer.search.linkedCrm.placeholder': 'Please select',
	'app.wecom.customer.search.linkedCrm.yes': 'Yes',
	'app.wecom.customer.search.linkedCrm.no': 'No',
	'app.wecom.customer.search.linkedCrm.all': 'All',
	'app.wecom.customer.search.tags': 'WeCom Tags',
	'app.wecom.customer.search.tags.placeholder': 'Please select',
	'app.wecom.customer.search.adder': 'Added by',
	'app.wecom.customer.search.adder.placeholder': 'Please select',
	'app.wecom.customer.search.hasPhone': 'Has Phone in Remark',
	'app.wecom.customer.search.hasPhone.placeholder': 'Please select',
	'app.wecom.customer.search.hasPhone.yes': 'Yes',
	'app.wecom.customer.search.hasPhone.no': 'No',
	'app.wecom.customer.search.hasPhone.all': 'All',
	'app.wecom.customer.search.addTime': 'Added At',
	'app.wecom.customer.search.addTime.range': 'Select date range',

	// Source enum
	'app.wecom.customer.source.wechat_add': 'WeChat Add',
	'app.wecom.customer.source.phone_search': 'Phone Search',
	'app.wecom.customer.source.group_add': 'Group Add',
	'app.wecom.customer.source.active_code': 'Live Code',
	'app.wecom.customer.source.manual_add': 'Manual Add',

	// Table columns
	'app.wecom.customer.table.name': 'Customer',
	'app.wecom.customer.table.tags': 'Tags',
	'app.wecom.customer.table.corpName': 'Company',
	'app.wecom.customer.table.adder': 'Added by',
	'app.wecom.customer.table.linkedCrm': 'Linked to CRM',
	'app.wecom.customer.table.addTime': 'Added At',

	// Action buttons(客户无需操作列 —— 直接点名称进详情)
	// 'app.wecom.customer.button.detail': 'Details',

	// Detail Modal
	'app.wecom.customer.detail.title': 'Customer Details',
	'app.wecom.customer.detail.wechatTag': '@WeChat',
	'app.wecom.customer.detail.nickname': 'Nickname',
	'app.wecom.customer.detail.remark': 'Remark',
	'app.wecom.customer.detail.tags': 'Tags',
	'app.wecom.customer.detail.leadId': 'Lead ID',
	'app.wecom.customer.detail.leadOwner': 'Lead Follower',

	// Detail — Activity Tab
	'app.wecom.customer.detail.tab.activity': 'Activity',
	'app.wecom.customer.detail.tab.archive': 'Session Archive',
	'app.wecom.customer.detail.activity.filter.all': 'All',
	'app.wecom.customer.detail.activity.empty': 'No more data',
	'app.wecom.customer.detail.activity.type.add': 'Friend Added',
	'app.wecom.customer.detail.activity.type.change_remark': 'Remark Changed',
	'app.wecom.customer.detail.activity.type.add_tag': 'Tag Added',
	'app.wecom.customer.detail.activity.type.remove_tag': 'Tag Removed',
	'app.wecom.customer.detail.activity.type.link_crm': 'CRM Linked',

	// Detail — Archive
	'app.wecom.customer.detail.archive.colleagueList': 'Colleagues who chatted with this customer',
	'app.wecom.customer.detail.archive.colleague.empty': 'No colleagues',
	'app.wecom.customer.detail.archive.message.empty': 'No chat history',

	// Empty state
	'app.wecom.customer.empty': 'No customers. Try adjusting filters or sync WeCom.'
}
